import React from 'react';
import PropTypes from 'prop-types';

import AppIcon from 'components/common/AppIcon/AppIcon';

PlanCheckIcon.propTypes = {
  color: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired
};

function PlanCheckIcon({color, isActive}) {
  let icon = isActive ? 'check-active' : 'check';

  return <AppIcon name={icon} color={color} />;
}

export default PlanCheckIcon;
